import React from "react"
import styled from "styled-components"
import FillIcon from "./FillIcon"

const FeatureGridItemWrapper = styled.div`
  text-align: center;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  padding: 20px 10px 40px 10px;
  margin: 0 auto;
`

const FeatureGridItemContent = styled.div`
  width: 30%;
  max-width: 300px;
  margin: 10px 5px 30px 5px;

  @media (max-width: 615px) {
    width: 45%;
  }
`

const FeatureGridItemIcon = styled.div`margin-bottom: 10px;`

const FeatureGridItemTitle = styled.h4`
  font-size: 16px;
  @media (max-width: 480px) {
    font-size: 14px;
  }
`

const FeatureGridItemDescription = styled.p`
  font-size: 15px;
  line-height: 21px;
  @media (max-width: 480px) {
    font-size: 13px;
    line-height: 17px;
  }
`

const FeatureGridItem = ({ features }) => {
  if (!features || features.length < 1) {
    return null
  }
  return (
    <FeatureGridItemWrapper>
      {features.map((feature, index, props) => (
        <FeatureGridItemContent key={index}>
          <FeatureGridItemIcon>
            <FillIcon name={feature.icon} />
          </FeatureGridItemIcon>
          <FeatureGridItemTitle>{feature.name}</FeatureGridItemTitle>
          <FeatureGridItemDescription>
            {feature.description}
          </FeatureGridItemDescription>
        </FeatureGridItemContent>
      ))}
    </FeatureGridItemWrapper>
  )
}

export default ({ features }) => <FeatureGridItem features={features} />



// WEBPACK FOOTER //
// ./src/components/FeatureGridItem.js